import React from 'react';
import PropTypes from 'prop-types';

import ToolbarTool from '../../../commonComponents/ToolbarTool';

const TextStyleRichTextTool = ({ isOpen, name }) => (
    <ToolbarTool className="TextStyleRichTextTool" isOpen={isOpen} name={name}>
        {/* using a div with a .png image here instead of an svg Icon
        because the gradient does not export correctly */}
        <div className="text-style-icon" />
    </ToolbarTool>
);

TextStyleRichTextTool.propTypes = {
    isOpen: PropTypes.bool,
    name: PropTypes.string,
};

export default TextStyleRichTextTool;
